import { Injectable } from '@angular/core';
import { NotificationsService } from 'angular2-notifications'

@Injectable()
export class MessageService {

	public isBusy: boolean = false;
	public appErrorPrompt?: string | null;
	public appError?: string | null;
	public hasAppAlert?: boolean | null;

	public options: any = {
		position: ['top', 'right'],
		timeOut: 8000,
		showProgressBar: true,
		lastOnBottom: false,
		preventDuplicates: true
	}

	constructor(private notificationService: NotificationsService) { 
		this.notificationService.warn({
			timeOut: 30000,
			pauseOnHover: true
		});
	}

	clearAppError() {
		this.appError = null;
		this.appErrorPrompt = null;
		this.hasAppAlert = false;
		this.notificationService.remove();
	}

	showAppError(prompt: any, message: any) {
		this.isBusy = false;
		this.hasAppAlert = true;
		this.appErrorPrompt = prompt;
		if (typeof (message) == 'object') {
			switch (message.status) {
				case 200: this.appError = 'Service unavailable. Server is reachable but refused our request.'; break;
				case 304: this.appError = 'The server has made no changes.'; this.appErrorPrompt = 'Heads Up!'; break;
				case 401: this.appError = 'Your session has expired.'; this.appErrorPrompt = 'Logged Out!'; break;
				case 403: this.appError = 'You are not authorized.'; break;
				case 404: this.appError = 'Server unavailable. Please try again later.'; break;
				case 500: this.appError = 'We hit a snag. Please try again later.'; this.appErrorPrompt = 'Oops!'; break;
				case 400: {
					console.log(message);
					if (message.error === undefined || message.error == null || message.error.detail === undefined || message.error.detail == null) {
						this.appErrorPrompt = 'Oops!';
						this.appError = 'We hit a snag. Please try again later.'; 
					} else {
						this.appError = message.error.detail;
					}
				}
				break;
				default: {
					if (message.status !== undefined && message.status != null){
						this.appError = 'Service unavailable. Server is reachable but refused our request.'; 
					} else {
						console.log(prompt, JSON.stringify(message));
						this.appError = 'We hit a snag.  Please try again later.';
						this.appErrorPrompt = 'Oops!';
					}
					break;
				}
			}
			
			if(message.status == 304) {
				this.notificationService.alert(this.appErrorPrompt, this.appError);
			} else {
				this.notificationService.error(this.appErrorPrompt, this.appError);
			}
		} else {
			this.appError = message;
			this.notificationService.error(this.appErrorPrompt, this.appError);
		}
	}

	showAppAlert(prompt: any, message: any) {
		this.isBusy = false;
		this.hasAppAlert = true;
		this.appError = message;
		this.appErrorPrompt = prompt;
		this.notificationService.alert(this.appErrorPrompt, this.appError);
	}

	showAppMessage(prompt: any, message: any) {
		this.isBusy = false;
		this.hasAppAlert = true;
		this.appError = message;
		this.appErrorPrompt = prompt;
		this.notificationService.success(this.appErrorPrompt, this.appError);
	}

	showAppInfo(prompt: any, message: any) {
		this.isBusy = false;
		this.hasAppAlert = true;
		this.appError = message;
		this.appErrorPrompt = prompt;
		this.notificationService.info(this.appErrorPrompt, this.appError);
	}

	showBasicMessage(prompt: any, message: any) {
		this.isBusy = false;
		this.hasAppAlert = true;
		this.appError = message;
		this.appErrorPrompt = prompt;
		this.notificationService.bare(this.appErrorPrompt, this.appError);
	}
}
